<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Integração de Usuários
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>

        <lista-unidades-select
          v-model="filtros.unidade"
        ></lista-unidades-select>
      </div>
      <div class="col-md-2 col-xs-6 col-sm-6">
        <div class="q-ml-sm texto-titulo-input">Nome</div>
        <q-input v-model="filtros.nome" class="input" dense outlined />
      </div>
      <div class="col-md-2 col-xs-6 col-sm-6">
        <div class="q-ml-sm texto-titulo-input">Matricula</div>
        <q-input v-model="filtros.matricula" class="input" dense outlined />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm"
          label="Filtrar"
          color="primary"
          no-caps
          icon="filter_alt"
          @click="listarFuncionarios()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Todos os Usuários do Sistema
        </span>
      </div>
      <q-table
        :columns="columns"
        :loading="loading"
        dense
        :rows="listaFuncionarios"
        class="tabela-tamanho-fixo"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-pagination
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-9">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Nome: </strong>
                    {{ props.row.nome }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Matricula: </strong>
                    {{ props.row.matricula }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Unidade: </strong>
                    {{ props.row.nome_unidade }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Cod. Centro: </strong>
                    {{ props.row.codigo_centro_custo }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Situação: </strong>
                    {{ props.row.situacao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Ult. Atualização: </strong>
                    {{ props.row.data_ultima_atualizacao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Data Integração: </strong>
                    {{
                      props.row.data_atualizacao_integracao
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Msg. Erro: </strong>
                    {{ props.row.msg_erro }}</span
                  >
                </div>
                <div class="col-2"></div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-matricula="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.matricula }}
          </q-td>
        </template>
        <template v-slot:body-cell-unidade="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.nome_unidade }}
          </q-td>
        </template>
        <template v-slot:body-cell-codigocentro="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.codigo_centro_custo }}
          </q-td>
        </template>
        <template v-slot:body-cell-situacao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.situacao }}
          </q-td>
        </template>
        <template v-slot:body-cell-dataintegracao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.data_atualizacao_integracao
                .split("-")
                .reverse()
                .join("/")
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-ultimaatualizacao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.data_ultima_atualizacao }}
          </q-td>
        </template>
        <template v-slot:body-cell-mensagemerro="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.msg_erro }}
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

const columns = [
  {
    name: "nome",
    label: "ID",
    align: "left",
  },
  {
    name: "matricula",
    label: "Matricula",
    align: "left",
  },
  {
    name: "unidade",
    label: "Unidade",
    align: "left",
  },
  {
    name: "codigocentro",
    label: "Cod. Centro",
    align: "left",
  },
  {
    name: "nomecentro",
    label: "Nome Centro",
    align: "left",
  },
  {
    name: "situacao",
    label: "Situação",
    align: "left",
  },
  {
    name: "ultimatualizacao",
    label: "Ult. Atualização",
    align: "left",
  },
  {
    name: "dataintegracao",
    label: "Data Integração",
    align: "left",
  },
  {
    name: "mensagemerro",
    label: "Msg. Erro",
    align: "left",
  },
];
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const listaFuncionarios = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    let loading = ref(false);
    let disable = ref(false);
    const filtros = ref({
      nome: "",
      matricula: "",
      unidade: "",
    });

    const listarFuncionarios = async (page = 0, rowsNumber = 10) => {
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch("integracao/listarUsuarios", {
          per_page: rowsNumber,
          page: page,
          nome: filtros.value.nome,
          matricula: filtros.value.matricula,
          unidade: filtros.value.unidade.id,
        });
        listaFuncionarios.value = response.data.results.data;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsNumber = response.data.results.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const paginarTabela = async () => {
      listarFuncionarios(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        listarFuncionarios();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarFuncionarios(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    onMounted(listarFuncionarios);

    return {
      columns,
      unidade,
      listarFuncionarios,
      listaFuncionarios,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      paginarTabela,
      filtros,
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .btn {
    margin: 6px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .btn-exportar {
    font-size: 12px;
  }
  .container-input-search {
    margin: 17px 0px;
  }
  .input-multiplo-grid {
    width: 100px;
  }
  .input-codigo-epi-grid {
    width: 70px;
    outline: none;
  }
}
</style>
